module.exports = __webpack_public_path__ + "static/media/help_important.11dd33e6.svg";